
import PublicLogin from './pages/PublicLogin.vue';
import LoginPage from './pages/LoginPage.vue';
import ResetPasswordPage from './pages/ResetPasswordPage.vue';
import RegisterPage from './pages/RegisterPage.vue';
import InvitePage from './pages/InvitePage.vue';
import CreateWorkspacePage from './pages/CreateWorkspacePage.vue';
import WorkspaceSelection from './pages/WorkspaceSelection.vue';

const routes = [
	{ path: "/account/login/", component: LoginPage },
	{ path: "/account/register/", component: RegisterPage },
	{ path: "/account/invite/:token/", component: InvitePage, props: true },
	{ path: "/account/password/reset/", component: ResetPasswordPage },
	{ path: "/account/workspaces/create/", component: CreateWorkspacePage },
	{ path: "/account/workspaces/", component: WorkspaceSelection },
	{ path: "/ac/l/", component: PublicLogin }
];

export default routes;
